import ScheduledMessagesAPI from '../../api/scheduledMessages';

export const SET_SCHEDULED_MESSAGES_UI_FLAG = 'SET_SCHEDULED_MESSAGES_UI_FLAG';
export const SET_CONVERSATION_SCHEDULED_MESSAGES =
  'SET_CONVERSATION_SCHEDULED_MESSAGES';
export const REMOVE_CONVERSATION_SCHEDULED_MESSAGE =
  'REMOVE_CONVERSATION_SCHEDULED_MESSAGE';
export const SET_ACCOUNT_SCHEDULED_MESSAGES = 'SET_ACCOUNT_SCHEDULED_MESSAGES';
export const REMOVE_ACCOUNT_SCHEDULED_MESSAGE =
  'REMOVE_ACCOUNT_SCHEDULED_MESSAGE';

export const state = {
  records: {},
  accountRecords: [],
  accountMeta: { currentPage: 1, totalPages: 1, totalCount: 0 },
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isFetchingAll: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getForConversation: $state => conversationId => {
    return $state.records[conversationId] || [];
  },
  getAccountScheduledMessages(_state) {
    return _state.accountRecords;
  },
  getAccountMeta(_state) {
    return _state.accountMeta;
  },
};

export const actions = {
  get: async ({ commit }, conversationId) => {
    commit(SET_SCHEDULED_MESSAGES_UI_FLAG, { isFetching: true });
    try {
      const { data } =
        await ScheduledMessagesAPI.getForConversation(conversationId);
      commit(SET_CONVERSATION_SCHEDULED_MESSAGES, { conversationId, data });
    } catch (error) {
      // Ignore error
    } finally {
      commit(SET_SCHEDULED_MESSAGES_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, { conversationId, content, scheduledAt }) => {
    commit(SET_SCHEDULED_MESSAGES_UI_FLAG, { isCreating: true });
    try {
      const { data } = await ScheduledMessagesAPI.createForConversation({
        conversationId,
        content,
        scheduledAt,
      });
      commit(SET_CONVERSATION_SCHEDULED_MESSAGES, {
        conversationId,
        data: undefined,
        appendRecord: data,
      });
      return data;
    } finally {
      commit(SET_SCHEDULED_MESSAGES_UI_FLAG, { isCreating: false });
    }
  },

  cancel: async ({ commit }, { conversationId, id }) => {
    commit(SET_SCHEDULED_MESSAGES_UI_FLAG, { isDeleting: true });
    try {
      await ScheduledMessagesAPI.cancelForConversation({ conversationId, id });
      commit(REMOVE_CONVERSATION_SCHEDULED_MESSAGE, { conversationId, id });
    } finally {
      commit(SET_SCHEDULED_MESSAGES_UI_FLAG, { isDeleting: false });
    }
  },

  getAll: async ({ commit }, { page = 1, status } = {}) => {
    commit(SET_SCHEDULED_MESSAGES_UI_FLAG, { isFetchingAll: true });
    try {
      const { data } = await ScheduledMessagesAPI.getAll({ page, status });
      commit(SET_ACCOUNT_SCHEDULED_MESSAGES, data);
    } finally {
      commit(SET_SCHEDULED_MESSAGES_UI_FLAG, { isFetchingAll: false });
    }
  },

  cancelAccountWide: async ({ commit }, id) => {
    commit(SET_SCHEDULED_MESSAGES_UI_FLAG, { isDeleting: true });
    try {
      await ScheduledMessagesAPI.delete(id);
      commit(REMOVE_ACCOUNT_SCHEDULED_MESSAGE, id);
    } finally {
      commit(SET_SCHEDULED_MESSAGES_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [SET_SCHEDULED_MESSAGES_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  [SET_CONVERSATION_SCHEDULED_MESSAGES](
    $state,
    { conversationId, data, appendRecord }
  ) {
    const existing = $state.records[conversationId] || [];
    const nextRecords = appendRecord ? [...existing, appendRecord] : data;
    $state.records = { ...$state.records, [conversationId]: nextRecords };
  },

  [REMOVE_CONVERSATION_SCHEDULED_MESSAGE]($state, { conversationId, id }) {
    const existing = $state.records[conversationId] || [];
    $state.records = {
      ...$state.records,
      [conversationId]: existing.filter(record => record.id !== id),
    };
  },

  [SET_ACCOUNT_SCHEDULED_MESSAGES]($state, { payload, meta }) {
    $state.accountRecords = payload;
    $state.accountMeta = {
      currentPage: meta.current_page,
      totalPages: meta.total_pages,
      totalCount: meta.total_count,
    };
  },

  [REMOVE_ACCOUNT_SCHEDULED_MESSAGE]($state, id) {
    $state.accountRecords = $state.accountRecords.filter(
      record => record.id !== id
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
